import { useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { IAdditionalSetupData } from "interfaces";
import { getFormattedDateTime } from "utills/helpers";

export const ChangeRegistrationInformation = ({
  additionalSetupData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="box-container p-4 text-sm sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="sm:col-span-2">
          <Label
            required
            id="change_registration_information.start_change_info_date"
            name={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.startDate"
            )}
          />
          {getFormattedDateTime(
            additionalSetupData?.start_change_info_date ?? ""
          )}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_registration_information.end_change_info_date"
            name={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.endDate"
            )}
          />
          {getFormattedDateTime(
            additionalSetupData?.end_change_info_date ?? ""
          )}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_registration_information.max_number_of_times_to_update_information"
            name={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.maxNumberOfTimes"
            )}
          />
          {additionalSetupData?.max_number_of_times_to_update_information}
        </div>
      </div>
    </div>
  );
};
